<template>
  <client-layout>
    <maintenance-contract-dialog
      v-model="isContractDialogOpened"
      :contract="openedContract"
    />
    <v-row no-gutters align="center" class="content-header">
      <span class="font-weight-bold">Contrats de maintenance</span>
      <v-spacer></v-spacer>
      <v-btn dark color="primary" elevation="0" @click="isNewContractDialogOpened = true">
        <v-icon left>add</v-icon>
        Nouveau contrat
      </v-btn>
    </v-row>
    <v-list class="pa-0 border-component">
      <template v-for="(contract, index) in contracts">
        <v-list-item
          :key="`maintenance-contract-${index}`"
          @click="openContractDialog(contract)"
        >
          <v-list-item-avatar>
            <v-icon>assignment</v-icon>
          </v-list-item-avatar>

          <v-row no-gutters>
            <v-col align="left">
              <v-list-item-content>
                <v-list-item-title><b>#{{ contract.num }}</b> - {{ contract.label }}</v-list-item-title>
                <v-list-item-subtitle>
                  {{ contract.nbEquipments }} équipements concernés
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-col>
            <div class="mt-3">
              <v-chip small color="green darken-1" text-color="white" v-if="contract.isActive">Actif</v-chip>
              <v-chip small color="grey darken-2" text-color="white" v-else>Terminé</v-chip>
            </div>
          </v-row>
        </v-list-item>
        <v-divider
          v-if="index + 1 < contracts.length"
          :key="index"
        ></v-divider>
      </template>
    </v-list>
  </client-layout>
</template>

<script>
import ClientLayout from '@/views/settings/clients/ClientLayout.vue';
import MaintenanceContractDialog from '@/components/MaintenanceContracts/MaintenanceContractDialog.vue';

export default {
  data: () => ({
    isNewContractDialogOpened: false,
    contracts: [
      { id: 1, num: `SG624`, label: `La Rochelle`, isActive: true, nbEquipments: 2 }, // eslint-disable-line
      { id: 2, num: `SG721`, label: `Poitiers`, isActive: false, nbEquipments: 3 }, // eslint-disable-line
      { id: 3, num: `SG291`, label: `Nantes`, isActive: true, nbEquipments: 8 }, // eslint-disable-line
      { id: 4, num: `SG429`, label: `La Roche sur Yon`, isActive: true, nbEquipments: 4 }, // eslint-disable-line
    ],
    isContractDialogOpened: false,
    openedContract: null,
  }),

  computed: {
  },

  methods: {
    openContractDialog(contract) {
      this.openedContract = contract;
      this.isContractDialogOpened = true;
    },
  },

  components: {
    ClientLayout,
    MaintenanceContractDialog,
  },
};
</script>
